/** Zeettu ↔ payzhe BTP bridge protocol version (semver). Bump when bridge API contract changes. */
export const ZEETTU_BRIDGE_VERSION = '2.0.0';

/** Expected payzhe BTP HTTP/WebSocket API major version. */
export const PAYZHE_BTP_EXPECTED_API_VERSION = '1';
